module.exports = __webpack_public_path__ + "media/images/icon__arrow-right--rb-light-gray@3x-d3ffb64e8783c18203d950265f69d621.png";